<template>
  <list-select
      ref="select"
      async
      :emit-only-value="false"
      v-on:input="(v) => $emit('input', v)"
      :search-data="search"
      :parse-callback="parse"
      v-model="model"
  />
</template>

<script>
import ListSelect from "@/reuse/input/ListSelect"
import {listTypes} from "@/domain/form/services/field"
export default {
  name: "FormFieldTypeSelect",
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      model: this.value,
      result: []
    }
  },
  watch: {
    value (v) {
      this.$nextTick(() => {
        if (v !== this.model) {
          this.$refs.select.autoSelectValue(v)
        } else {
          console.log('Sem bind')
        }
      })
    }
  },
  components: {ListSelect},
  methods: {
    search (terms) {
      console.log('Find', this.model)
      const filtros = []
      if (terms) {
        filtros.push('search=' + terms)
      }
      return new Promise((resolve, reject) => {
        listTypes()
            .then(response => {
              console.log(response.data)
              this.result = response.data
              let list = response.data.map((obj) => {
                return {
                  ...obj,
                  id: obj.value,
                  value: obj.value,
                  label: obj.helper.label
                }
              })/*.sort((a, b) => {
                if (a.helper.label > b.helper.label) {
                  return 1;
                }
                if (a.helper.label < b.helper.label) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              })*/
              resolve(list)
            })
            .catch(({response}) => {
              reject(response)
            })
      })
    },
    parse (v) {
      console.log('Parse', v)
      if (v && v.label) {
        return v.label
      }
      return v
    }
  }
}
</script>
